import { render, staticRenderFns } from "./hero-gallery.global.vue?vue&type=template&id=0275d60f&"
import script from "./hero-gallery.global.vue?vue&type=script&lang=js&"
export * from "./hero-gallery.global.vue?vue&type=script&lang=js&"
import style0 from "./hero-gallery.global.vue?vue&type=style&index=0&id=0275d60f&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports